import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { E as p, S as f } from "./icons.types-0722eef5.js";
function u({ title: i, titleId: e, size: a, width: n, height: o, extended: r = !1, ...s }) {
  const c = r ? p : f, t = a ? c[a] : n || c[r ? "s" : "l"], h = a ? c[a] : o || c[r ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: t,
      height: h,
      "aria-labelledby": e,
      ...s,
      children: [
        i ? /* @__PURE__ */ l("title", { id: e, children: i }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Map_layer_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M36 54.746 7.34 35.999l4.728-3.093 22.84 14.941c.334.22.714.33 1.092.33.378 0 .758-.11 1.092-.33l22.84-14.944 4.73 3.096L36 54.746Zm28.662-7.584L36 65.91 7.34 47.162l4.728-3.096 22.84 14.942c.334.219.714.328 1.092.328.378 0 .758-.11 1.092-.328l22.837-14.942 4.733 3.096ZM36 6.09l28.662 18.746L36 43.585 7.34 24.835 36 6.09Zm34.5 29.91a2.11 2.11 0 0 0-.947-1.772L63.73 30.42l5.823-3.809c.59-.386.947-1.053.947-1.775a2.11 2.11 0 0 0-.947-1.771L37.092 1.826a1.99 1.99 0 0 0-2.184 0L2.444 23.064a2.115 2.115 0 0 0-.944 1.771c0 .722.357 1.389.944 1.775l5.823 3.809-5.823 3.808A2.115 2.115 0 0 0 1.5 36c0 .721.357 1.388.944 1.775l5.823 3.808-5.823 3.806a2.12 2.12 0 0 0-.944 1.774c0 .719.357 1.389.944 1.775l32.464 21.234c.334.22.714.329 1.092.329.378 0 .758-.11 1.092-.329l32.46-21.234a2.12 2.12 0 0 0 .948-1.775c0-.721-.357-1.388-.947-1.774l-5.823-3.806 5.823-3.808c.59-.387.947-1.054.947-1.775Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Map_layer_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  u as MapLayer
};
